const initialState = {
  account: {
    isLoading: true,
    connected: false,
  }
}

const startAccountLoading = (state) => ({
  ...state,
  account: {
    ...state.account,
    isLoading: true
  }
})

const accountLoaded = (state, {
  external_user_id: email,
  display_connect_toggle: displayConnectToggle,
  connected,
  email_confirmed: emailConfirmed
}) => ({
  ...state,
  account: {
    ...state.account,
    email,
    displayConnectToggle,
    connected,
    emailConfirmed
  }
})

const stopAccountLoading = (state) => ({
  ...state,
  account: {
    ...state.account,
    isLoading: false
  }
})

const disconnectAccount = (state) => ({
  ...state,
  account: {
    ...state.account,
    connected: false
  }
})

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case 'PAYPAL_FETCH_ACCOUNT':
      return startAccountLoading(state)
    case 'PAYPAL_FETCH_ACCOUNT_SUCCESS':
      return accountLoaded(state, payload)
    case 'PAYPAL_FETCH_ACCOUNT_COMPLETE':
      return stopAccountLoading(state)
    case 'PAYPAL_DISCONNECT_ACCOUNT':
      return disconnectAccount(state)
    default:
      return state
  }
}
